// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* .el-form-item >>> .el-input is-disabled .el-input__inner {\r\n    color: #696969 !important;\r\n} */\n.el-form-item[data-v-78df3c41] .el-form-item__content .el-textarea_inner {\r\n    color: #696969 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
